import request from '@/api/request.js'

// 新增
export function NewsCategoryInsert(data) {
    return request({
        url: '/api/news/newscategoryinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function NewsCategoryDelete(id) {
    return request({
        url: `/api/news/newscategorydelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function NewsCategoryUpdate(id, data) {
    return request({
        url: `/api/news/newscategoryupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function NewsCategoryGetById(id) {
    return request({
        url: `/api/news/getnewscategorybyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function NewsCategoryGetList(params) {
    return request({
        url: '/api/news/getnewscategorylist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function NewsCategoryGetPageList(params) {
    return request({
        url: '/api/news/getnewscategorypagelist',
        method: 'get',
        params: params
    })
}